// Facebook Pixel Helper - Track conversion events
// Usage: import { trackEvent } from '@/lib/facebook-pixel';

export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
    console.log(`[FB Pixel] Tracked: ${eventName}`, params);
  }
};

// Événements prédéfinis
export const fbEvents = {
  // Quand un visiteur consulte une fiche machine
  viewMachine: (machine) => {
    trackEvent('ViewContent', {
      content_name: machine.name,
      content_category: 'Machine',
      content_type: 'product',
      content_ids: [machine.id],
      value: machine.price || 0,
      currency: 'EUR'
    });
  },

  // Quand un visiteur démarre le configurateur
  startConfigurator: () => {
    trackEvent('InitiateCheckout', {
      content_category: 'Configurateur'
    });
  },

  // Quand un visiteur sélectionne une machine dans le configurateur
  selectMachine: (machine) => {
    trackEvent('AddToCart', {
      content_name: machine.name,
      content_type: 'product',
      content_ids: [machine.id],
      value: machine.price || 0,
      currency: 'EUR'
    });
  },

  // Quand un visiteur soumet une demande de devis
  submitQuoteRequest: (data) => {
    trackEvent('Lead', {
      content_name: data.machine_name || 'Demande de devis',
      content_category: 'Quote Request',
      value: data.estimated_value || 0,
      currency: 'EUR'
    });
  },

  // Quand un visiteur soumet le formulaire de contact
  submitContact: () => {
    trackEvent('Contact', {
      content_category: 'Contact Form'
    });
  },

  // Quand un visiteur consulte une page accessoire
  viewAccessory: (accessory) => {
    trackEvent('ViewContent', {
      content_name: accessory.name,
      content_category: 'Accessoire',
      content_type: 'product',
      content_ids: [accessory.id],
      value: accessory.selling_price || 0,
      currency: 'EUR'
    });
  },

  // Quand un visiteur demande un devis accessoire
  requestAccessoryQuote: (accessory) => {
    trackEvent('Lead', {
      content_name: accessory.name,
      content_category: 'Accessoire Quote',
      value: accessory.selling_price || 0,
      currency: 'EUR'
    });
  },

  // Quand un visiteur consulte un article de blog
  viewBlogPost: (post) => {
    trackEvent('ViewContent', {
      content_name: post.title,
      content_category: 'Blog',
      content_type: 'article'
    });
  },

  // Quand un visiteur consulte la page financement
  viewFinancing: () => {
    trackEvent('ViewContent', {
      content_category: 'Financement',
      content_type: 'page'
    });
  },

  // Événement personnalisé
  custom: (eventName, params) => {
    trackEvent(eventName, params);
  }
};

export default fbEvents;
